export { BestSellers } from './BestSellers'
export type { BestSellersProps } from './BestSellers'
